import { forwardRef, useImperativeHandle } from 'react';
import { useInsertTicketList } from './useInsertTicketList';
import { InsertTicketData } from '@/components/editor/TicketPlugin/types';

interface TicketListInsertProviderProps {
  children: React.ReactNode;
}

export const TicketListInsertProvider = forwardRef<
  (ticketsData: InsertTicketData | InsertTicketData[]) => void,
  TicketListInsertProviderProps
>(({ children }, ref) => {
  const insertTicketList = useInsertTicketList();

  useImperativeHandle(ref, () => insertTicketList, [insertTicketList]);

  return <>{children}</>;
});

TicketListInsertProvider.displayName = 'TicketListInsertProvider';
